module.exports = "/_next/static/images/whats-murder-island-player-video-ff061645de46aafbf288d439375a2c75.png";